import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import teamImg from "../../assests/Team/Team.png";
import "./Team.css";

const Team: React.FC = () => {
  const imageWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const imageWrapper = imageWrapperRef.current;
    if (!imageWrapper) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add animation class to both corner decorations
            const topRightCorner = imageWrapper.querySelector('.corner-decor.top-right');
            const bottomLeftCorner = imageWrapper.querySelector('.corner-decor.bottom-left');
            
            if (topRightCorner) {
              topRightCorner.classList.add('animate-in');
            }
            if (bottomLeftCorner) {
              bottomLeftCorner.classList.add('animate-in');
            }
          }
        });
      },
      {
        threshold: 0.3, // Trigger when 30% of the element is visible
        rootMargin: '0px 0px -50px 0px' // Slight offset from bottom
      }
    );

    observer.observe(imageWrapper);

    // Cleanup
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div style={{display:"flex",justifyContent:"center"}}>
    <section className="team-section">
      <div className="team-container">
        {/* Section Heading */}
        <div className="style">
          <div className="about-container">
            <h3 className="team-subtitle"> <span className="dot"></span>Our Story</h3>
            <h1 className="team-title">Our Journey, Our Team</h1>
          </div>
        </div>

        <Row className="align-items-center">
          {/* Left Content */}
          <Col md={6} className="mb-4 mb-md-0">
            <div className="team-text">
              <h3 className="team-highlight">
                The People Behind 
                <h3 className="team-xyloite">Xyloite</h3>
              </h3>
              <p className="team-description">
                At Xyloite, our strength lies in our people. United by passion
                and innovation, our team brings diverse skills and experiences
                together to shape solutions that truly make a difference. Every
                story, every idea, and every effort contributes to building the
                Xyloite journey driven by collaboration, creativity, and a
                shared vision for the future.
              </p>
            </div>
          </Col>

          {/* Right Content - Image */}
          <Col md={6} className="text-center">
            <div className="team-image-wrapper" ref={imageWrapperRef}>
              <img src={teamImg} alt="Xyloite Team" className="team-image" />
              <div className="corner-decor top-right"></div>
              <div className="corner-decor bottom-left"></div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
    </div>
  );
};

export default Team;